import { projectAttributes } from "@bkry/bowline-redux/projects";
import { getWalletAttributes } from "@bkry/bowline-redux/wallets";
import { useWeb3React } from "@web3-react/core";
import { sha256 } from "js-sha256";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Cookies from "universal-cookie";

const useAuthorization = () => {
  const location = useLocation();
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [isBlocked, setIsBlocked] = useState(null);
  const cookieHandler = new Cookies();
  const { account } = useWeb3React();
  const project = useSelector(projectAttributes);
  const wallet = useSelector((state) => getWalletAttributes(state, account));
  const signedIn = useSelector((state) => state.wallets.siweSuccess);

  useEffect(() => {
    if (project?.access_mode) {
      switch (project.access_mode) {
        case "anyone":
          setIsAuthorized(true);
          setIsBlocked(false);
          break;
        case "connected_wallets":
          setIsAuthorized(!!account);
          setIsBlocked(!account);
          break;
        case "signed_in_wallets":
          setIsAuthorized(signedIn);
          setIsBlocked(!signedIn);
          break;
        case "holder_wallets":
          const isMintRoute = /minting/i.test(location.pathname);
          setIsAuthorized(signedIn && wallet?.current_wallet_is_holder);
          setIsBlocked(
            !signedIn || (!wallet?.current_wallet_is_holder && !isMintRoute)
          );
          break;
        case "password":
          const accessKey = cookieHandler.get("access_key") || "";
          setIsAuthorized(sha256(accessKey).toString() === project?.access_key);
          setIsBlocked(false);
          break;
      }
    }
  }, [project, account, signedIn, wallet, cookieHandler]);

  return { isAuthorized, isBlocked };
};

export default useAuthorization;
